import { makeEroadStyles } from "./makeEroadStyles";

const useGlobalStyles = makeEroadStyles((theme) => ({
  "@global": {
    html: {
      fontSize: 10,
    },
    body: {
      fontFamily: theme.typography.fonts.primary,
      color: theme.colors.onsurfaceFont,
    },
  },
}));

export { useGlobalStyles };
